import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop';

import { of } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule, DialogRef, IconModule } from '@hglobal/common';
import { environment } from '@pt/environment';
import { P2PLimits } from '@pt/models';

@Component({
  selector: 'pt-p2p-share-policy',
  templateUrl: './p2p-share-policy.component.html',
  styleUrls: ['./p2p-share-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, IconModule, TranslateModule],
})
export class P2pSharePolicyComponent {
  readonly #dialogRef = inject(DialogRef);
  readonly #httpClient = inject(HttpClient);
  readonly #translateService = inject(TranslateService);

  readonly #limits = toSignal<P2PLimits>(environment.useMocks
    ? of({ perOne: 10, perMonth: 100, approvalEnabled: true })
    : this.#httpClient.get<P2PLimits>(`${environment.apiHost}banking/admin/transfer-limits/`));

  readonly text = computed(() => {
    if (this.#limits()) {
      const { perOne, perMonth } = this.#limits();
      return this.#translateService.instant('p2pSharePolicy.text', { perOne, perMonth });
    } else {
      return '';
    }
  });

  close(isAgreed: boolean): void {
    this.#dialogRef.close(isAgreed);
  }
}
